import { Star } from "lucide-react";

export const RatingStars = ({ rating }) => {
  if (!rating || !rating.count) return null;
  return (
    <div className="flex items-center gap-0.5" data-testid="rating-stars">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={13}
          className={i <= Math.round(rating.avg) ? "fill-[#E4BD44] text-[#E4BD44]" : "text-[#3a3a3a]"} />
      ))}
      <span className="text-[11px] text-[#9a9484] ml-1.5">{rating.avg.toFixed(1)} ({rating.count})</span>
    </div>
  );
};
